
import { Card } from "primereact/card";
import { useHistory } from "react-router";

//kyc imports
import { useDispatch, useSelector } from "react-redux";
import { NextButton, PrevButton } from "./kycSidebar";
import { SaveButton } from "./declerationDetails";
import SignatureComponent from "./SignatureComponent";
import { Dialog } from "primereact/dialog";
import BiometricsComponent from "./BiometricsComponent";
import { Button } from "primereact/button";
import { setLeftBiometricsImage, setRightBiometricsImage, setSignature } from "../../redux/biometricsSlice";
import { setGuardianSignature } from "../../redux/guardianSlice";

const Biometrics = ({ viewBiometrics, setViewBiometrics }) => {
    const history = useHistory();
    const signatureSli = useSelector(
        (state) => state.biometricsDetailsList.signature
    );
    const guardianSignatureSli = useSelector(
        (state) => state.guardianDetails.signature
    );
    const leftImageSli = useSelector(
        (state) => state.biometricsDetailsList.leftImage
    );
    const rightImageSli = useSelector(
        (state) => state.biometricsDetailsList.rightImage
    );
    const biometricsErrorObj = useSelector((state) => state.biometricsDetailsList.errors);
    const guardianBiometricsErrorObj = useSelector((state) => state.guardianDetails.errors);

    const formType = useSelector((state) => state.routerData.formType);
    const isMinor = useSelector((state) => state.personalDetails.isMinor);
    const isSignature = useSelector((state) => formType === 'I' ? state.personalDetails.isSignature : state.companyDetails.isSignature);


    //Kyc
    const header = () => (
        <h3 className="p-col-12 p-md-12 text-center">
            <i className="pi pi-key"></i> Thumb Print
        </h3>
    );
    const footer = () => (
        <div className="p-grid" style={{ justifyContent: 'center' }}>
            <div className="p-col-20">
                <SaveButton onlySave={true} />
                {/* <Button
                    className="p-button-success"
                    label="Save"
                    iconPos="right"
                    onClick={(e) => {
                        console.log("asdfsa")
                    }
                    }
                    style={{ margin: 5, flex: 1 }}
                /> */}
            </div>
        </div>
    );

    return (
        <Dialog
            header={header}
            visible={viewBiometrics}
            style={{ width: "50%" }}
            // footer={renderFooter}
            onHide={() => {
                setViewBiometrics(false);
            }}
        >
            <Card footer={footer}>
                <div>
                    <div className="p-grid p-fluid">
                        <div
                            className="p-col-12 p-md-12"
                            style={{
                                display: "flex",
                                placeItems: "center",
                                justifyContent: "center",
                                flexDirection: "row",
                            }}
                        >
                            <div>
                                <h4 className="p-col-12 p-md-12" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <p className="section-title">Left Thumb Print</p>
                                </h4>
                                <BiometricsComponent title={"Biometrics *"}
                                    error={biometricsErrorObj && biometricsErrorObj.signature && biometricsErrorObj.signature.message}
                                    setBiometricsImage={setLeftBiometricsImage}
                                    biometricsSli={leftImageSli}
                                />
                            </div>
                            <div>
                                <h4 className="p-col-12 p-md-12" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <p className="section-title">Right Thumb Print</p>
                                </h4>
                                <BiometricsComponent title={"Biometrics *"}
                                    error={biometricsErrorObj && biometricsErrorObj.signature && biometricsErrorObj.signature.message}
                                    setBiometricsImage={setRightBiometricsImage}
                                    biometricsSli={rightImageSli}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="p-grid p-fluid">
                        <div
                            className="p-field p-col-12 p-md-12"
                            style={{
                                display: "flex",
                                placeItems: "center",
                                justifyContent: "center",
                                flexDirection: "row",
                            }}
                        >
                            <div>
                                <h4 className="p-col-12 p-md-12" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <p className="section-title">Signature</p>
                                </h4>
                                <SignatureComponent title={"Signature *"}
                                    error={biometricsErrorObj && biometricsErrorObj.signature && biometricsErrorObj.signature.message}
                                    setSignature={setSignature}
                                    signatureSli={signatureSli}
                                />
                            </div>
                            {isMinor &&
                                <div>
                                    <h4 className="p-col-12 p-md-12" style={{ display: 'flex', justifyContent: 'center' }}>
                                        <p className="section-title">Guardian Signature</p>
                                    </h4>
                                    <SignatureComponent title={"Guardian Signature *"}
                                        error={guardianBiometricsErrorObj && guardianBiometricsErrorObj.signature && guardianBiometricsErrorObj.signature.message}
                                        setSignature={setGuardianSignature}
                                        signatureSli={guardianSignatureSli}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Card>
        </Dialog>
    );
};

export default Biometrics;
